import { AIR_OPT_OUT_RELEASE_VARIANT, AIR_OPT_OUT_FEATURE_RELEASE_DATE, GUEST_MINIMUM_RELEASE_VARIANT, HOTEL_ROOMSUBBLOCK_RELEASE_VARIANT, HOTEL_OPT_OUT_RELEASE_VARIANT, HOTEL_OPT_OUT_FEATURE_RELEASE_DATE, getWidgetVisibilityLogicPermittedList } from '@cvent/event-ui-experiments';
import { useMemo } from 'react';
export const shouldUseAirOptOutFeature = (state) => {
    var _a, _b;
    return ((_a = state === null || state === void 0 ? void 0 : state.experiments) === null || _a === void 0 ? void 0 : _a.featureRelease) >= AIR_OPT_OUT_RELEASE_VARIANT &&
        new Date((_b = state === null || state === void 0 ? void 0 : state.event) === null || _b === void 0 ? void 0 : _b.createdDate) > AIR_OPT_OUT_FEATURE_RELEASE_DATE;
};
export const shouldUseHotelOptOutFeature = (state) => {
    var _a, _b;
    return ((_a = state === null || state === void 0 ? void 0 : state.experiments) === null || _a === void 0 ? void 0 : _a.featureRelease) >= HOTEL_OPT_OUT_RELEASE_VARIANT &&
        new Date((_b = state === null || state === void 0 ? void 0 : state.event) === null || _b === void 0 ? void 0 : _b.createdDate) > HOTEL_OPT_OUT_FEATURE_RELEASE_DATE;
};
export const isGraphQLForEventCapacitiesVariantON = (state) => { var _a; return ((_a = state.experiments) === null || _a === void 0 ? void 0 : _a.graphQLForEventCapacitiesVariant) >= 1; };
export const shouldUseRoomSubBlockFeature = (state) => { var _a; return ((_a = state.experiments) === null || _a === void 0 ? void 0 : _a.featureRelease) >= HOTEL_ROOMSUBBLOCK_RELEASE_VARIANT; };
export const isGuestMinimumEnabled = (state) => { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.experiments) === null || _a === void 0 ? void 0 : _a.featureRelease) >= GUEST_MINIMUM_RELEASE_VARIANT; };
export const useNewVisibleProductsForRegCart = (state) => { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.experiments) === null || _a === void 0 ? void 0 : _a.useNewVisibleProductsForRegCart) > 0; };
export const useFlexWidgetVisibilityLogicPermittedList = () => {
    return useMemo(() => getWidgetVisibilityLogicPermittedList(), []);
};
const QuestionWidgetTypes = [
    'ChoiceQuestion',
    'OpenEndedTextQuestion',
    'DateTimeQuestion',
    'ConsentQuestion',
    'FileUploadQuestion'
];
export const isWidgetVisibilityLogicEnabledForQuestions = () => {
    const permittedWidgetTypes = new Set(getWidgetVisibilityLogicPermittedList()
        .filter(({ isEnabled }) => isEnabled)
        .map(({ widgetType }) => widgetType));
    return QuestionWidgetTypes.every(type => permittedWidgetTypes.has(type));
};
